var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-box"},[_c('div',{staticClass:"product-list"},_vm._l((_vm.productList),function(vitem,vindex){return _c('router-link',{key:vindex,staticClass:"item",attrs:{"tag":"div","to":{ name: 'rapidly', params: { id: vitem.Id } }}},[_c('div',{staticClass:"top"},[_vm._v(_vm._s(_vm.showProductName(vitem.Id))+"/USDT")]),_c('div',{staticClass:"bottom",style:({
          color:
            vitem.percentage < 0
              ? _vm.basicConfig.FallColour
              : _vm.basicConfig.RiseColour
        })},[_c('div',{staticClass:"now-price"},[_vm._v(_vm._s(_vm.showPrice(vitem.Price)))]),_c('div',{staticClass:"mini-text"},[_vm._v(" "+_vm._s(vitem.percentage > 0 ? `+${vitem.percentage}` : vitem.percentage)+"% ")])])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }